import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function VegetableCutlet() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 20px 40px 20px",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            Vegetable Cutlet
          </h1>
          <span className="season-badge season-monsoon" style={{ marginBottom: 24 }}>🌧️ Best in Monsoon</span>
          <ImageWithFallback
            src="/veg_cutlet.png"
            alt="Vegetable Cutlet"
            className="recipe-image-anim"
            style={{
              width: 400,
              height: 300,
              objectFit: "cover",
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 32,
            }}
          />
          <div
            style={{
              maxWidth: 800,
              fontSize: "1.1rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Ingredients:
            </h2>

            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginTop: 16, marginBottom: 12 }}>
              For the Cutlet:
            </h3>
            <ul className="ingredient-list" style={{ marginBottom: 20, paddingLeft: 20 }}>
              <li>3 medium potatoes, boiled and mashed</li>
              <li>1/2 cup mixed vegetables (carrots, beans, peas, corn)</li>
              <li>2 slices bread, soaked in water and squeezed</li>
              <li>2 green chilies, finely chopped</li>
              <li>1 tsp ginger, grated</li>
              <li>1/2 tsp garam masala</li>
              <li>1/2 tsp red chili powder</li>
              <li>1/4 tsp turmeric powder</li>
              <li>Salt to taste</li>
              <li>2 tbsp fresh coriander, chopped</li>
              <li>1 tbsp lemon juice</li>
            </ul>

            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              For Coating:
            </h3>
            <ul style={{ marginBottom: 20, paddingLeft: 20 }}>
              <li>1/2 cup all-purpose flour (maida)</li>
              <li>1 cup breadcrumbs</li>
              <li>Water as needed</li>
              <li>Oil for shallow frying</li>
            </ul>

            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Instructions:
            </h2>
            <ol className="instructions-list" style={{ paddingLeft: 20 }}>
              <li style={{ marginBottom: 12 }}>
                <strong>Prepare vegetables:</strong> Finely chop mixed vegetables and lightly boil or steam them until just tender. Drain excess water.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Make mixture:</strong> In a large bowl, combine mashed potatoes, cooked vegetables, squeezed bread, green chilies, ginger, garam masala, red chili powder, turmeric, salt, coriander, and lemon juice. Mix well.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Check consistency:</strong> The mixture should be firm enough to shape. If too wet, add a tablespoon of bread crumbs or flour.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Shape cutlets:</strong> Divide the mixture into equal portions and shape into round or oval patties (about 1/2 inch thick).
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Prepare coating station:</strong> Make a smooth slurry with flour and water (consistency like pancake batter). Place breadcrumbs in a separate plate.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Coat cutlets:</strong> Dip each cutlet in the flour slurry, then roll in breadcrumbs, ensuring even coating on all sides.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Shallow fry:</strong> Heat oil in a pan over medium heat. Place cutlets and fry for 3-4 minutes on each side until golden brown and crispy.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Drain and serve:</strong> Remove cutlets and place on paper towels to drain excess oil. Serve hot with ketchup, mint chutney, or tamarind sauce.
              </li>
            </ol>

            <div
              className="chef-tips-box"
              style={{
                background: "#f8f9fa",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips:
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Ensure vegetables are well-drained to prevent soggy cutlets</li>
                <li>Refrigerate shaped cutlets for 15 minutes for easier handling</li>
                <li>For healthier version, bake at 375°F (190°C) for 20-25 minutes</li>
                <li>Can be frozen before frying - thaw and fry when needed</li>
                <li>Add grated paneer or cheese for extra richness</li>
                <li>Perfect tea-time snack or party appetizer</li>
              </ul>
            </div>

            <div
              className="health-benefits-box"
              style={{
                background: "#eef9f0",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Packed with mixed vegetables, offering fiber, vitamins, and minerals in every bite.</li>
                <li>Potatoes provide quick, satisfying energy along with potassium.</li>
                <li>Baking or air-frying instead of deep-frying cuts down significantly on added fat.</li>
                <li>A great way to get kids to eat more vegetables in a familiar, crispy snack.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default VegetableCutlet;